import * as Sentry from "@sentry/gatsby"

Sentry.init({
  dsn: process.env.GATSBY_SENTRY_DSN,
  environment: process.env.GATSBY_CURRENT_BRANCH,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: parseFloat(process.env.GATSBY_SENTRY_TRACES_SAMPLE_RATE),
  tracePropagationTargets: [
    "localhost",
    "https://checkr.com",
    "https://development.checkr.com",
    "https://staging.checkr.com",
  ],
})
